import backToTopIcon from "@images/back-to-top-icon.png";

const ScrollToTopButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-4 right-4 p-2 text-white rounded-full shadow hover:bg-black hover:bg-opacity-10"
      title="Back to Top"
    >
      <img src={backToTopIcon} alt="back to top" className="w-8" />
    </button>
  );
};

export default ScrollToTopButton;
